const firstPathSegment = (path) => `/${path.split('/')[1]}`;
const pathWithoutSearch = (path) => path.split(/[?#]/, 1)[0];
const isPathOrDescendant = (activePathname, pathname) => activePathname === pathname || activePathname.startsWith(`${pathname}/`);
export const navigationPathState = ({ activePathname, isSublink, pathname, subLinks, }) => {
    const activePath = pathWithoutSearch(activePathname);
    const navigationPath = pathWithoutSearch(pathname);
    const currentFirstSegment = firstPathSegment(activePath);
    const isAssistant = currentFirstSegment === '/assistant';
    const isExactMatch = navigationPath === activePath;
    const isDirectSublink = subLinks === null || subLinks === void 0 ? void 0 : subLinks.some((subLink) => pathWithoutSearch(subLink.pathname) === activePath);
    const isFirstSegmentMatch = firstPathSegment(navigationPath) === currentFirstSegment;
    const isSubLinkFirstSegmentMatch = subLinks === null || subLinks === void 0 ? void 0 : subLinks.some((subLink) => firstPathSegment(pathWithoutSearch(subLink.pathname)) ===
        currentFirstSegment);
    const isHighlighted = isSublink
        ? isPathOrDescendant(activePath, navigationPath)
        : isExactMatch || isFirstSegmentMatch || isSubLinkFirstSegmentMatch;
    const isCurrent = isExactMatch || isDirectSublink || (isAssistant && isHighlighted);
    return { isCurrent, isHighlighted };
};
